import { patchState, signalStore, withComputed, withMethods, WritableStateSource } from '@ngrx/signals';
import { addEntity, setAllEntities, updateEntity, withEntities } from '@ngrx/signals/entities';
import { MgsWebApi } from '../../mgs-webapi.service';
import { computed, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IKidsHotel } from '@mng/mgs-lib';
import { IOption } from '@mng/mng-inputs';

export const KidsHotelStore = signalStore(
  { providedIn: 'root' },

  withEntities<IKidsHotel>(),
  withComputed((state) => ({
    loaded: computed(() => state.entities()?.length > 0),
    entitiesCopy: computed(() => structuredClone(state.entities())),
    options: computed(() =>
      state
        .entities()
        ?.filter((hotel: IKidsHotel) => hotel.aktiv)
        .map((hotel: IKidsHotel) => ({ value: hotel.id, name: hotel.name }) as IOption)
    )
  })),
  withMethods((state) => {
    const webApi = inject(MgsWebApi);

    return {
      load: async (force = false) => {
        const hasToLoad = force || !state.entities()?.length;
        if (hasToLoad) {
          const hotels = await firstValueFrom(webApi.kidsHotels());
          patchState(state, setAllEntities(hotels));
        }
      },
      speichern: async (hotel: IKidsHotel) => {
        return updateOrAdd(state, await firstValueFrom(webApi.kidsHotelSave(hotel)), hotel.id ? 'update' : 'add');
      }
    };
  })
);

export type KidsHotelStore = InstanceType<typeof KidsHotelStore>;

export function updateOrAdd<T extends { id: number | string }>(
  state: WritableStateSource<object>,
  entity: T,
  aktion: 'update' | 'add'
) {
  patchState(state, aktion === 'update' ? updateEntity({ id: entity.id, changes: entity }) : addEntity(entity));
  return entity;
}
